import React from 'react';
import { Upload, Button, message } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import { validateUploadedFile } from '../../utils/fileSecurityValidator';


class PictureUpload extends React.Component {
  state = {
    fileList: []
  };


  render() {

    const { count } = this.props
    const { fileList } = this.state;

    const props = {
      listType: "file",
      accept: '.jpeg,.jpg,.png,.pdf,.zip',
      onRemove: file => {
        this.setState(state => {
          const index = state.fileList.indexOf(file);
          const newFileList = state.fileList.slice();
          newFileList.splice(index, 1);
          return {
            fileList: newFileList,
          };
        });
      },
      beforeUpload: async (file) => {

        const isLt2M = file.size / 1024 < 10000;
        if (!isLt2M) {
          message.error('محدودیت حجم فایل ۱۰ مگابایت است.');

          return false;
        }
        if (this.state.fileList.length >= count) {
          message.error(`نهایتا ${count} عکس میتوانید آپلود کنید`);

          return false;
        }

        const validationResult = await validateUploadedFile(file);
        if (!validationResult.isValid) {
          message.error(`فایل حاوی محتوای غیرمجاز است`);
          file.__rejected = true;
          return validationResult.isValid
        }

        switch (file.type) {
          case 'image/jpeg':
            this.setState(state => ({
              fileList: [...state.fileList, file],
            }));
            return false;
          case 'image/png':
            this.setState(state => ({
              fileList: [...state.fileList, file],
            }));
            return false;
          case 'image/jpg':
            this.setState(state => ({
              fileList: [...state.fileList, file],
            }));
            return false;
          case 'application/pdf':
            this.setState(state => ({
              fileList: [...state.fileList, file],
            }));
            return false;
          case 'application/x-zip-compressed':
          case 'application/zip':
            this.setState(state => ({
              fileList: [...state.fileList, file],
            }));
            return false;
          default:
            message.error('نوع فایل انتخابی صحیح نمی باشد.');
            return false;
        }

      },
      fileList,
    };

    return (
      <>
        <Upload {...props}>
          <Button icon={<UploadOutlined />} style={{ textAlign: 'left', display: 'block', marginBottom: '10px' }}>آپلود مستندات</Button>
        </Upload>
      </>
    );
  }
}

export default PictureUpload




